import { action, get, set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  navbarSettings: service(),
  store: service(),

  model(params) {
    return this.store
      .findRecord('organization/entity-detail', params.id)
      .then((record) => {
        set(this, 'navbarSettings.title', get(record, 'entity.name'));
        return record;
      });
  },

  refreshDonorRoute: action(function () {
    this.refresh();
  }),
});
